import { checkIfCanMixDressings } from '../../helpers';
import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfDressingsCanBeMixed: Guard = function (args): boolean {
  const { context } = args;
  const { productRestaurant: restaurant, isDelivery, modifications } = context;

  const activeModifications = modifications?.active ?? [];

  return checkIfCanMixDressings({ restaurant, isDelivery, activeModifications }); // prettier-ignore
};
